import graphql from './graphql';

const query = /* GraphQL */ `
  query UserEvaluation_consultUserEvaluation($lessonId: ID!, $userId: ID!) {
    UserEvaluation_consultUserEvaluation(lessonId: $lessonId, userId: $userId) {
      id
      grade
    }
  }
`;

const UserEvaluationConsult = async ({ lessonId, userId }) =>
  graphql(query, { lessonId, userId }).then(
    // eslint-disable-next-line camelcase
    ({ UserEvaluation_consultUserEvaluation }) =>
      // eslint-disable-next-line camelcase
      UserEvaluation_consultUserEvaluation
  );
export default UserEvaluationConsult;
